import { MEDIA } from "@brg/ui"
import { FC, useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { ArrowTopRightIconSmall, QuestionCircleIcon } from "shared/icons"
import styled from "styled-components"

export interface AvatarSourceBadgeProps {
  sourceUrl?: string | null
}

const Root = styled.div`
  position: absolute;
  right: 8px;
  bottom: 8px;
  z-index: 2;
`

const Trigger = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  padding: 0;
  background: none;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  outline: none;
  -webkit-tap-highlight-color: transparent;

  &:focus,
  &:focus-visible,
  &:active {
    outline: none;
    box-shadow: none;
  }

  &:hover svg path {
    fill: #ffffff;
  }
`

const Chip = styled.div`
  position: absolute;
  left: 50%;
  bottom: 28px;
  transform: translateX(-50%);
  width: 360px;
  height: 45px;
  box-sizing: border-box;
  padding: 2px 12px 4px;
  background: #E7E7E7;
  color: #70706F;
  border-radius: 6px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  font-family: Inter, sans-serif;
  font-size: 11px;
  line-height: 13px;
  pointer-events: auto;

  @media ${MEDIA.TABLET} {
    width: min(280px, calc(100vw - 32px));
  }
`

const Title = styled.div`
  font-weight: 600;
  margin-bottom: 2px;
`

const Hint = styled.div`
  color: #6b6b6b;
`

const Link = styled.a`
  font-weight: 600;
  text-decoration: none;
  color: #70706F;
  display: inline-flex;
  align-items: baseline;
  gap: 2px;

  &:hover {
    color: #909090;
  }

  svg {
    align-self: center;
    position: relative;
    top: 1px;
  }
`

export const AvatarSourceBadge: FC<AvatarSourceBadgeProps> = ({ sourceUrl }) => {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!open) return
    const onDoc = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false)
    }
    document.addEventListener("mousedown", onDoc)
    return () => document.removeEventListener("mousedown", onDoc)
  }, [open])

  if (!sourceUrl) return null

  let host = sourceUrl
  try {
    host = new URL(sourceUrl).hostname.replace(/^www\./, "")
  } catch {}

  return (
    <Root ref={ref}>
      <Trigger
        type="button"
        aria-label={t("pages.designer.avatar_source.title")}
        onClick={(e) => {
          e.stopPropagation()
          setOpen((v) => !v)
        }}
      >
        <QuestionCircleIcon />
      </Trigger>
      {open && (
        <Chip onMouseDown={(e) => e.stopPropagation()}>
          <Title>{t("pages.designer.avatar_source.title")}</Title>
          <Hint>
            {t("pages.designer.avatar_source.hint")}{" "}
            <Link href={sourceUrl} target="_blank" rel="noopener noreferrer">
              {host}
              <ArrowTopRightIconSmall />
            </Link>
          </Hint>
        </Chip>
      )}
    </Root>
  )
}
import { MEDIA } from "@brg/ui"
import { FC, useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { ArrowTopRightIconSmall, QuestionCircleIcon } from "shared/icons"
import styled from "styled-components"

export interface AvatarSourceBadgeProps {
  sourceUrl?: string | null
}

const Root = styled.div`
  position: absolute;
  right: 8px;
  bottom: 8px;
  z-index: 2;
`

const Trigger = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  padding: 0;
  background: none;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  outline: none;
  -webkit-tap-highlight-color: transparent;

  &:focus,
  &:focus-visible,
  &:active {
    outline: none;
    box-shadow: none;
  }

  &:hover svg path {
    fill: #ffffff;
  }
`

const Chip = styled.div`
  position: absolute;
  left: 50%;
  bottom: 28px;
  transform: translateX(-50%);
  width: 360px;
  height: 45px;
  box-sizing: border-box;
  padding: 2px 12px 4px;
  background: #E7E7E7;
  color: #70706F;
  border-radius: 6px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  font-family: Inter, sans-serif;
  font-size: 11px;
  line-height: 13px;
  pointer-events: auto;

  @media ${MEDIA.TABLET} {
    width: min(280px, calc(100vw - 32px));
  }
`

const Title = styled.div`
  font-weight: 600;
  margin-bottom: 2px;
`

const Hint = styled.div`
  color: #6b6b6b;
`

const Link = styled.a`
  font-weight: 600;
  text-decoration: none;
  color: #70706F;
  display: inline-flex;
  align-items: baseline;
  gap: 2px;

  &:hover {
    color: #909090;
  }

  svg {
    align-self: center;
    position: relative;
    top: 1px;
  }
`

export const AvatarSourceBadge: FC<AvatarSourceBadgeProps> = ({ sourceUrl }) => {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!open) return
    const onDoc = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false)
    }
    document.addEventListener("mousedown", onDoc)
    return () => document.removeEventListener("mousedown", onDoc)
  }, [open])

  if (!sourceUrl) return null

  let host = sourceUrl
  try {
    host = new URL(sourceUrl).hostname.replace(/^www\./, "")
  } catch {}

  return (
    <Root ref={ref}>
      <Trigger
        type="button"
        aria-label={t("pages.designer.avatar_source.title")}
        onClick={(e) => {
          e.stopPropagation()
          setOpen((v) => !v)
        }}
      >
        <QuestionCircleIcon />
      </Trigger>
      {open && (
        <Chip onMouseDown={(e) => e.stopPropagation()}>
          <Title>{t("pages.designer.avatar_source.title")}</Title>
          <Hint>
            {t("pages.designer.avatar_source.hint")}{" "}
            <Link href={sourceUrl} target="_blank" rel="noopener noreferrer">
              {host}
              <ArrowTopRightIconSmall />
            </Link>
          </Hint>
        </Chip>
      )}
    </Root>
  )
}
